import { decamelizeKeys } from 'humps'

import request from '@/utils/request'

const fetchApiKeys = () => {
  return request({
    path: '/merchants/get-api-keys',
    method: 'GET',
  })
}

const fetchOtherKeys = () => {
  return request({
    path: '/merchants/get-other-keys',
    method: 'GET',
  })
}

const sendOtp = ({ email }) => {
  return request({
    path: '/merchants/otp/send_otp',
    method: 'POST',
    data: {
      email,
    },
  })
}

const confirmOtp = ({ email, code }) => {
  return request({
    path: '/merchants/otp/confirm',
    method: 'POST',
    data: {
      email,
      code,
    },
  })
}

const verifyOtp2FA = ({
  email,
  otp,
  phoneNumber,
  countryCode,
  deviceIdentifier,
}) => {
  return request(
    {
      path: '/merchants/2fa/otp/verify',
      method: 'POST',
      data: {
        email,
        otp,
        phone_number: phoneNumber,
        country_code: countryCode,
        device_identifier: deviceIdentifier,
      },
    },
    {
      options: {
        hideMessage: true,
      },
    }
  )
}
const resendOtp2FA = (dataToBeSent) => {
  return request({
    path: '/merchants/2fa/otp/resend',
    method: 'POST',
    data: decamelizeKeys(dataToBeSent),
  })
}
export {
  fetchApiKeys,
  fetchOtherKeys,
  sendOtp,
  confirmOtp,
  verifyOtp2FA,
  resendOtp2FA,
}
